import React from 'react';
import { Listbox } from '@headlessui/react';

export interface SelectBoxOption {
  value: string | number;
  label: string;
  disabled?: boolean;
}

function SelectBox({
  options,
  selected,
  setSelected,
}: {
  options: SelectBoxOption[];
  selected: string | number;
  setSelected: (a: string | number) => void;
}) {
  return (
    <div>
      <Listbox value={selected} onChange={setSelected}>
        <Listbox.Button className="rounded bg-gls-logo-yellow text-black">{selected}</Listbox.Button>
        <Listbox.Options className="absolute bg-gray-100 p-2 z-50 shadow">
          {options.map((option) => (
            <Listbox.Option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
              className="mt-1 px-3 py-1 text-gray-900 hover:cursor-pointer hover:bg-gls-logo-blue hover:text-white">
              {option.label}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  );
}

export default SelectBox;
